import React from 'react';
import { ExternalLink } from 'lucide-react';

const affiliates = [
  {
    name: 'Airalo',
    desc: 'eSIM data plans for 200+ countries. Stay connected from the moment you land.',
    url: 'https://www.airalo.com?referral_code=francisco7033',
    tag: 'Connectivity',
  },
  {
    name: 'SafetyWing',
    desc: 'Travel & health insurance built for nomads, expats, and remote workers.',
    url: 'https://safetywing.com/?referenceID=mundalo&utm_source=mundalo&utm_medium=ambassador',
    tag: 'Insurance',
  },
  {
    name: 'Wise',
    desc: 'Send money internationally at the real exchange rate with low, transparent fees.',
    url: 'https://wise.com/invite/rib/franciscor118',
    tag: 'Banking',
  },
];

const RelocationAffiliate = () => (
  <section className="py-20 border-t border-[#e0dbd4] bg-white">
    <div className="max-w-5xl mx-auto px-6 lg:px-12">
      <h2 className="text-2xl text-[#FFFFFF] mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>Recommended Tools</h2>
      <p className="text-[#888] text-sm mb-10">Resources our clients trust - curated by the Mundalo.</p>
      <div className="grid md:grid-cols-3 gap-4">
        {affiliates.map((a) => (
          <a
            key={a.name}
            href={a.url}
            target="_blank"
            rel="nofollow noopener sponsored"
            className="block p-6 border border-[#e0dbd4] bg-[#FAF7F2] rounded-lg hover:border-[#E8A830]/50 transition group"
            data-testid={`affiliate-${a.name.toLowerCase()}`}
          >
            <div className="text-[10px] text-[#888] uppercase tracking-wider mb-3">{a.tag}</div>
            <h3 className="text-[#FFFFFF] font-semibold mb-2 flex items-center gap-2">
              {a.name}
              <ExternalLink className="w-3.5 h-3.5 opacity-0 group-hover:opacity-60 transition" />
            </h3>
            <p className="text-[#666] text-xs">{a.desc}</p>
          </a>
        ))}
      </div>
    </div>
  </section>
);

export default RelocationAffiliate;
